// Centralized helpers for storing/restoring per-job selected location (city)

const LOC_KEY = (jobId: string | number | undefined | null) => `job:${jobId}:selected_location_city`;

export type LocationValue = string | '';

export function setStoredLocation(jobId: string | number | undefined | null, value: LocationValue): void {
  try {
    if (value === undefined || value === null) {
      localStorage.removeItem(LOC_KEY(jobId));
      return;
    }
    localStorage.setItem(LOC_KEY(jobId), String(value));
  } catch (_) {
    /* noop */
  }
}

export function getStoredLocation(jobId: string | number | undefined | null): LocationValue | undefined {
  try {
    const raw = localStorage.getItem(LOC_KEY(jobId));
    if (raw === null) return undefined; // not set
    return raw;
  } catch (_) {
    return undefined;
  }
}

export function clearStoredLocation(jobId: string | number | undefined | null): void {
  try {
    localStorage.removeItem(LOC_KEY(jobId));
  } catch (_) {
    /* noop */
  }
}


